import React from 'react'

const AuthDecor = () => {
  return (
    <svg
      className="quizify-auth-decor"
      width="280"
      height="230"
      viewBox="0 0 320 260"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="quizifyAuthDecorGradient" x1="56" y1="38" x2="280" y2="220" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B8AFF" />
          <stop offset="0.55" stopColor="#145FCB" />
          <stop offset="1" stopColor="#0048B3" />
        </linearGradient>
        <linearGradient id="quizifyAuthDecorSoft" x1="72" y1="78" x2="246" y2="182" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B8AFF" stopOpacity="0.28" />
          <stop offset="1" stopColor="#0048B3" stopOpacity="0.12" />
        </linearGradient>
      </defs>
      <g opacity="0.12">
        <circle cx="178" cy="122" r="76" fill="url(#quizifyAuthDecorSoft)" />
        <circle cx="178" cy="122" r="74" stroke="url(#quizifyAuthDecorGradient)" strokeWidth="18" />
        <circle cx="178" cy="122" r="47" stroke="url(#quizifyAuthDecorGradient)" strokeWidth="4" opacity="0.65" />
        <path
          d="M228 176L278 226"
          stroke="url(#quizifyAuthDecorGradient)"
          strokeWidth="22"
          strokeLinecap="round"
        />
        <path
          d="M236 170L286 220"
          stroke="#00347F"
          strokeWidth="5"
          strokeLinecap="round"
          opacity="0.45"
        />

        <g stroke="url(#quizifyAuthDecorGradient)" strokeLinecap="round">
          <path d="M159 94H218" strokeWidth="9" />
          <path d="M159 124H212" strokeWidth="9" />
          <path d="M159 154H205" strokeWidth="9" />
        </g>
        <g fill="url(#quizifyAuthDecorGradient)">
          <circle cx="132" cy="94" r="8" />
          <circle cx="132" cy="124" r="8" />
          <circle cx="132" cy="154" r="8" />
        </g>

        <g fill="url(#quizifyAuthDecorGradient)" opacity="0.95">
          <rect x="40" y="86" width="5" height="5" rx="1.5" />
          <rect x="58" y="86" width="7" height="7" rx="2" />
          <rect x="80" y="84" width="11" height="11" rx="2" />
          <rect x="101" y="89" width="8" height="8" rx="2" />
          <rect x="54" y="116" width="6" height="6" rx="2" />
          <rect x="73" y="111" width="12" height="12" rx="2" />
          <rect x="94" y="119" width="7" height="7" rx="2" />
          <rect x="33" y="148" width="4" height="4" rx="1.5" />
          <rect x="53" y="146" width="7" height="7" rx="2" />
          <rect x="72" y="151" width="9" height="9" rx="2" />
          <rect x="92" y="143" width="13" height="13" rx="2" />
        </g>

        <path
          d="M35 104H96M26 134H83M48 174H112"
          stroke="url(#quizifyAuthDecorGradient)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="1 12"
          opacity="0.9"
        />
      </g>
    </svg>
  )
}

export default AuthDecor
